<template>
    <BaseContainer>
        <span slot="principal">
            <v-content class="pr-2 pl-2">
                <v-toolbar class="ma-2" style="border-radius: 30px;" dense>
                    <v-btn icon link to="/">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>

                    <v-toolbar-title v-show="$vuetify.breakpoint.mdAndUp">
                        Instâncias de WhatsApp
                    </v-toolbar-title>

                    <v-spacer/>

                    <v-tabs v-if="abas.length" v-model="aba" right show-arrows class="abas">
                        <v-tab v-for="item in abas" :key="item.chave">
                            <v-icon small left>{{ item.icone }}</v-icon>
                            {{ item.titulo }}
                        </v-tab>
                    </v-tabs>
                </v-toolbar>

                <v-alert v-if="!abas.length" type="info" text class="ma-2">
                    Você não tem permissão para consultar as instâncias de WhatsApp.
                </v-alert>

                <v-tabs-items v-else v-model="aba" touchless class="transparente">
                    <v-tab-item v-for="item in abas" :key="item.chave">
                        <TabInstancias v-if="item.chave === 'instancias'" ref="instancias"/>
                        <TabPods v-else-if="item.chave === 'pods'" @ver-instancias="verInstancias"/>
                        <TabHistorico v-else/>
                    </v-tab-item>
                </v-tabs-items>
            </v-content>
        </span>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer';
import TabInstancias from './TabInstancias';
import TabPods from './TabPods';
import TabHistorico from './TabHistorico';

export default {
    name: 'InstanciasWhatsapp',

    components: {
        BaseContainer,
        TabInstancias,
        TabPods,
        TabHistorico,
    },

    data: () => ({
        aba: 0,
    }),

    computed: {
        abas() {
            const lista = [];

            if (this.checkPermission('zapercontrol_instancias_consultar')) {
                lista.push({ chave: 'instancias', titulo: 'Instâncias', icone: 'mdi-whatsapp' });
                lista.push({ chave: 'pods', titulo: 'Pods', icone: 'mdi-server' });
                lista.push({ chave: 'historico', titulo: 'Histórico', icone: 'mdi-history' });
            }

            return lista;
        },
    },

    methods: {
        verInstancias(pod) {
            this.aba = 0;

            this.$nextTick(() => {
                const tab = this.$refs.instancias && this.$refs.instancias[0];

                if (!tab) return;

                tab.filtros.host = pod.host;
                tab.filtros.porta = String(pod.porta);
                tab.carregar(1);
            });
        },
    },
};
</script>

<style scoped>
.abas {
    max-width: 420px;
}

.transparente >>> .v-window__container {
    background: transparent;
}
</style>
